import TextField, { TextFieldProps } from '@mui/material/TextField';

export type AppTextFieldProps = TextFieldProps;

/** Outlined full-width field — default for forms across client and admin. */
export default function AppTextField(props: AppTextFieldProps) {
  return <TextField fullWidth size="small" variant="outlined" {...props} />;
}
